import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomMenuBarService {

  constructor() { }

  adminMenuBar() {
   return [
      {
        label: 'Contenido',
        icon: 'pi pi-fw pi-file-import',
        items: [
          {
            label: 'Blogs',
            icon: 'pi pi-fw pi-book',
            routerLink: ['/platform/blogs']
          },
          {
            label: 'Secciones',
            icon: 'pi pi-fw pi-images',
            routerLink: ['/platform/sections']
          }
        ]
      },
      {
        label: 'Administración',
        icon: 'pi pi-fw pi-cog',
        items: [
          {
            label: 'Usuarios',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/platform/users']
          },
          {
            label: 'Transacciones',
            icon: 'pi pi-database',
            routerLink: ['/platform/balances']
          },
          {
            label: 'Tipos de trasacciones',
            icon: 'pi pi-database',
            routerLink: ['/platform/balances/types']
          },
          {
            label: 'Log contraseñas',
            icon: 'pi pi-list',
            routerLink: ['/platform/users/log-password']
          },
          {
            label: 'Areas',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/areas']
          },
        ]
      },
      {
        label: 'Información',
        icon: 'pi pi-fw pi-info-circle',
        items: [
          {
            label: 'Terminos y condiciones',
            icon: 'pi pi-fw pi-shield',
            routerLink: ['/platform/termns-and-conditions']
          }
        ]
      },
      {
        label: 'Catálogo',
        icon: 'pi pi-fw pi-align-justify',
        items: [
          {
            label: 'Productos',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/products']
          },
          {
            label: 'Categorias',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/categories']
          },
          {
            label: 'Marcas',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/brands']
          },
          {
            label: 'Colores',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/colors']
          },
          {
            label: 'Sistemas de medida',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/measurement-systems']
          }
        ]
      },
      {
        label: 'Onemall',
        icon: 'pi pi-fw pi-align-justify',
        items: [
          {
            label: 'Proveedores Onemall',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/providers']
          }
        ]
      },
      {
        label: 'Pedidos',
        icon: 'pi pi-fw pi-cart-plus',
        items: [
          {
            label: 'Todos',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/orders/all']
          },
          {
            label: 'Por aprobar',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/orders/to-be-approved']
          },
          {
            label: 'Productos solicitados',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/orders/products']
          },
          {
            label: 'Productos por finalizar',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/orders/to-finalize']
          }
        ]
      }
    ];
  }

  analystMenuBar(){
    return [
      {
        label: 'Administración',
        icon: 'pi pi-fw pi-cog',
        items: [
          {
            label: 'Usuarios',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/platform/users']
          },
          {
            label: 'Transacciones',
            icon: 'pi pi-database',
            routerLink: ['/platform/balances']
          },
          {
            label: 'Tipos de trasacciones',
            icon: 'pi pi-database',
            routerLink: ['/platform/balances/types']
          }
        ]
      },
      {
        label: 'Pedidos',
        icon: 'pi pi-fw pi-cart-plus',
        items: [
          {
            label: 'Todos',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/orders/all']
          },
          {
            label: 'Por aprobar',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/orders/to-be-approved']
          },
        ]
      }
    ];
  }

  providerMenuBar(){
    return [
      {
        label: 'Catálogo',
        icon: 'pi pi-fw pi-align-justify',
        items: [
          {
            label: 'Productos',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/products']
          },
          {
            label: 'Categorias',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/categories']
          },
          {
            label: 'Marcas',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/brands']
          },
          {
            label: 'Colores',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/colors']
          },
          {
            label: 'Sistemas de medida',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/measurement-systems']
          }
        ]
      },
      {
        label: 'Onemall',
        icon: 'pi pi-fw pi-align-justify',
        items: [
          {
            label: 'Proveedores Onemall',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/providers']
          }
        ]
      },
      {
        label: 'Pedidos',
        icon: 'pi pi-fw pi-cart-plus',
        items: [
          {
            label: 'Productos solicitados',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/orders/products']
          },
          {
            label: 'Productos por finalizar',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/platform/orders/to-finalize']
          }
        ]
      }
    ];
  }

}
